import { useEffect, useState } from 'react'
import { useServerTimeOffset } from '@shared/hooks/useServerTime'

const pad = (value: number) => String(value).padStart(2, '0')

const pluralize = (value: number, singular: string, plural: string) =>
  `${value} ${value === 1 ? singular : plural}`

const formatRemaining = (ms: number) => {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000))
  const days = Math.floor(totalSeconds / 86400)

  if (days < 1) {
    const hours = Math.floor((totalSeconds % 86400) / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
  }

  if (days < 7) return pluralize(days, 'dia', 'dias')

  if (days < 30) return pluralize(Math.floor(days / 7), 'semana', 'semanas')

  if (days < 365) return pluralize(Math.floor(days / 30), 'mês', 'meses')

  return pluralize(Math.floor(days / 365), 'ano', 'anos')
}

export const useCountdown = (endsAt?: Date | string | number) => {
  const offsetMs = useServerTimeOffset()
  const target = endsAt ? new Date(endsAt).getTime() : 0

  const [remaining, setRemaining] = useState(() => Math.max(0, target - (Date.now() + offsetMs)))

  useEffect(() => {
    if (!endsAt) return

    const tick = () => setRemaining(Math.max(0, target - (Date.now() + offsetMs)))

    tick()
    const interval = setInterval(tick, 1000)

    return () => clearInterval(interval)
  }, [target, endsAt, offsetMs])

  return formatRemaining(remaining)
}
